import { useCallback, useMemo } from 'react'
import type { DUR } from '@truepill/tpos-types'
import { DURStatus } from '@truepill/tpos-types'
import { ToolBarButton } from 'components/ToolBarButton'
import DURConfirmationModal from 'modals/DURConfirmationModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { AlertTriangle } from 'react-feather'
import type { SideToolBarProps } from 'types'

function hasModerateOrSevereDUR(fill?: SideToolBarProps['fill']): boolean {
  if (!fill || !fill.durScreenings || !fill.durScreenings.length) return false
  const durs: DUR[] = fill.durScreenings[fill.durScreenings.length - 1]?.results || []
  return durs.some(dur => dur.status === DURStatus.MODERATE || dur.status === DURStatus.SEVERE)
}

export const DurButton = ({ fill }: Pick<SideToolBarProps, 'fill'>) => {
  const { showModal } = useModalContext()
  const reviewRequired = useMemo(() => hasModerateOrSevereDUR(fill), [fill])

  const handleDurClick = useCallback(() => {
    if (reviewRequired && fill) {
      showModal(() => <DURConfirmationModal fill={fill} confirmationCallback={() => {}} />)
    }
  }, [reviewRequired, fill, showModal])

  return (
    <ToolBarButton
      disabled={!reviewRequired}
      label="DUR"
      icon={AlertTriangle}
      tooltipText="DUR"
      clickCallback={handleDurClick}
      badgeStatus={reviewRequired ? 'alert' : undefined}
    />
  )
}
